import { makeAutoObservable } from 'mobx';

import { ThemeMode } from '../types/theme';

const COOKIE_KEY = 'themeMode';

function getCookieTheme(): ThemeMode {
    const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_KEY}=([^;]*)`));
    return (match ? decodeURIComponent(match[1]) : 'light') as ThemeMode;
}

function setCookieTheme(mode: ThemeMode) {
    const maxAge = 365 * 24 * 60 * 60;
    document.cookie = `${COOKIE_KEY}=${encodeURIComponent(mode)}; max-age=${maxAge}; path=/; SameSite=Lax`;
}

export class ThemeStore {
    private _mode: ThemeMode;

    constructor() {
        this._mode = getCookieTheme();
        makeAutoObservable(this);
    }

    get mode(): ThemeMode {
        return this._mode;
    }

    toggle() {
        this._mode = this._mode === 'light' ? 'dark' : 'light';
        setCookieTheme(this._mode);
    }
}
